export default class Color {
  static black = new Color('#000000')
  static white = new Color('#ffffff')
  static formats = ['hex','rgb','rgba']
  constructor(value) {
    if (typeof(value)==='string'&&value.length>0) {
      this.fromString(value)
    } else {
      // rgb value is between 0-255, a (alpha) is between 0.0-1.0
      this.r = 0
      this.g = 0
      this.b = 0
      this.a = 1
    }
  }
  alpha(a) {
    if (typeof(a)==='number'&&a>=0&&a<=1) {
      const color = new Color(this.toString())
      color.a = a
      return color
    }
    return this
  }
  inverse() {
    const {r,g,b} = this
    const max = 255
    const rgb = [max-r,max-g,max-b]
    return new Color(`rgb(${rgb.join(',')})`)
  }
  luminance() {
    const {r,g,b} = this
    const L = r*.299+g*.587+b*.114
    if (L>186) return Color.black
    return Color.white
  }
  fromString(s) {
    if (typeof(s)==='string'&&s.length>0) {
      if (s.charAt(0)==='#') {
        const rgb = s.slice(1)
        this.r = parseInt(rgb.slice(0,2),16)
        this.g = parseInt(rgb.slice(2,4),16)
        this.b = parseInt(rgb.slice(4,6),16)
        if (typeof(this.a)!=='number') {
          this.a = 1
        }
      } else if (s.startsWith('rgba')) {
        const rgba = s.trim().slice(5,s.length-1).split(',')
        const rgb = rgba.slice(0,rgba.length-1).map(e=>parseInt(e))
        this.r = rgb[0]
        this.g = rgb[1]
        this.b = rgb[2]
        this.a = parseFloat(rgba.slice(rgba.length-1))
      } else if (s.startsWith('rgb')) {
        const rgb = s.trim().slice(4,s.length-1).split(',').map(e=>parseInt(e))
        this.r = rgb[0]
        this.g = rgb[1]
        this.b = rgb[2]
        if (typeof(this.a)!=='number') {
          this.a = 1
        }
      }
    }
    return this
  }
  isEqual(c) {
    if (c instanceof Color) {
      const {r,g,b,a} = this
      return c.r===r&&c.g===g&&c.b===b&&c.a===a
    }
    return false
  }
  toString(p) {
    const {r,g,b,a} = this
    if (p==='hex'||p==='#') {
      const toHex=n=>{
        const hex = n.toString(16)
        if (hex.length===1) return `0${hex}`
        return hex
      }
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`
    }
    if (p==='rgb') {
      return `rgb(${r},${g},${b})`
    }
    const alpha = Number.isInteger(a)?`${a}.0`:a.toString()
    return `rgba(${r},${g},${b},${alpha})`
  }
}
